const nav = document.querySelector('.nav-main');
let lastScrollTop = 0;

if (nav) {
    window.addEventListener("scroll", function () {

        let currentScroll = window.pageYOffset || document.documentElement.scrollTop;

        if (currentScroll > lastScrollTop && lastScrollTop >= 0 && currentScroll > 0) {
            // Hide nav if the user scrolls down
            nav.classList.add('is-collapsed');
        } else {
            // Show nav if the user scrolls down or has not scrolled yet
            nav.classList.remove('is-collapsed');
        }
        lastScrollTop = currentScroll;

    });
}
